import { z } from 'zod'
import { Timestamp } from './common.js'
import { RoutePublic } from './route.js'

export const Favorite = z.object({
  user_id: z.string().uuid(),
  route_id: z.string().uuid(),
  created_at: Timestamp,
})
export type Favorite = z.infer<typeof Favorite>

export const FavoriteCreateInput = z.object({
  route_id: z.string().uuid(),
})
export type FavoriteCreateInput = z.infer<typeof FavoriteCreateInput>

export const FavoriteWithRoute = Favorite.extend({
  route: RoutePublic.pick({
    id: true,
    slug: true,
    title: true,
    summary: true,
    cover_image_url: true,
    geometry_url: true,
    activities: true,
    distance_km: true,
    ascent_m: true,
    updated_at: true,
  }),
})
export type FavoriteWithRoute = z.infer<typeof FavoriteWithRoute>
